/* eslint-disable max-len */
export const osnTick32Icon = {
  data: `<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path
    d="M16.0001 29.3327C23.3639 29.3327 29.3334 23.3631 29.3334 15.9993C29.3334 8.63555 23.3639 2.66602 16.0001 2.66602C8.63628 2.66602 2.66675 8.63555 2.66675 15.9993C2.66675 23.3631 8.63628 29.3327 16.0001 29.3327Z"
    stroke="#1BB096"
    stroke-width="2"
    stroke-linecap="square"
  />
  <path
    d="M9.75 17.0276L13.2467 20.7374C13.5567 21.0653 14.0833 21.0894 14.4242 20.7912C14.46 20.7591 14.4942 20.7245 14.5242 20.6868L22.25 11"
    stroke="#1BB096"
    stroke-width="2"
    stroke-linecap="round"
  />
</svg>`,
  name: 'tick32',
};
